import { Component } from "preact";
import { connect } from "react-redux";
import Button from "../../../components/Button";
import config from "../../../config";
import { css } from "emotion";

const info = css`
  flex: 1;
  @media (max-width: 900px) {
    margin-bottom: 12px;
  }
`;

const actionsBlock = css({
  maxWidth: 500,
  width: "100%",
  textAlign: "right",
  p: {
    color: "#5a626c",
    marginBottom: 4,
    textAlign: "right"
  },
  "@media(max-width: 900px)": {
    width: "auto",
    textAlign: "left",
    p: {
      textAlign: "right"
    }
  },
  "&:after": {
    clear: "both",
    content: '""',
    display: "block"
  }
});

const viewButton = {
  marginRight: 8,
  "@media (max-width: 900px)": {
    marginRight: 8
  }
};

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      deleteOpen: false,
      verifyOpen: false
    };
  }

  render() {
    const { currentEvent } = this.props;
    let eventUrl = `${config("TICKETING_URL")}/${currentEvent.data.slug}`;
    let viewTxt = "View";

    const eventHeader = css`
      border-radius: 4px;
      background: rgba(255, 255, 255, 0.9);
      padding: 18px;
      margin: 0 0 24px 0;
      display: flex;
      @media (max-width: 900px) {
        display: block;
        padding: 14px;
      }
    `;

    return (
      <div className={eventHeader}>
        <div className={info}>
          <h3 style={{ fontSize: 20, fontWeight: 400 }}>
            {" "}
            {currentEvent.data.name}
          </h3>
          <DatesListDisplay dates={currentEvent.data.dates} />
        </div>
        <div className={actionsBlock}>
          <a href={eventUrl} target="_blank" style={{ float: "right" }}>
            <Button style={viewButton} ariaLabel={viewTxt}>
              {viewTxt}
            </Button>
          </a>
        </div>
      </div>
    );
  }
}

const DatesListDisplay = ({ dates }) => {
  if (!dates) {
    return null;
  }
  const activeDates = dates.filter(date => !date.disabled);
  const datesInOrder = activeDates.sort((a, b) =>
    a.startDate > b.startDate ? 1 : -1
  );
  const date = datesInOrder[0];
  const dateStr =
    date && date.display ? `${date.display.date}, ${date.display.time}` : "";
  return (
    <span>
      {dateStr}{" "}
      {datesInOrder.length > 1 ? (
        <span>+ {datesInOrder.length - 1} more</span>
      ) : (
        ""
      )}
    </span>
  );
};
export default connect(
  (state, ownProps) => ({
    currentEvent: state.event
  }),
  {}
)(Header);



// WEBPACK FOOTER //
// ./routes/public/editOrder/Header.js